import React from 'react';
import { Box, Typography } from '@mui/material';

const AddIdeaPlaceholderMessage = () => {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      textAlign: 'center',
      minHeight: '80vh'
    }}>
      <Typography
        component="h1"
        variant="h4"
        color="text.secondary"
        sx={{
          fontFamily: 'Inter',
          fontSize: '22px',
          fontWeight: 500,
          color: '#B0BEC5',
          marginTop: '30px'
        }}
      >
        Please select or create an idea to continue.
      </Typography>
    </Box>
  );
};

export default AddIdeaPlaceholderMessage;
